<template>
  <div class="terms">
    <h3 class="terms-title">New terms and conditions</h3>
    <div class="form-group double vanilla terms-mt">
      <p>
        Hi there! We've recently updated the Fees and Terms & Conditions. You
        can review the updates here.<br />
        <strong
          ><a href="/terms-and-conditions" @click.prevent="handleTermsClick"
            >here</a
          ></strong
        >
        should link to the T&Cs site.
      </p>
    </div>
    <div class="terms-check">
      <input type="checkbox" v-model="isChecked" /> Don't show this message
      again
    </div>
    <div class="modal-actions">
      <div class="action">
        <button type="button" class="button primary" @click="confirmAction">
          <span>Ok</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseModal from "../Base";

// TODO loader

export default {
  extends: BaseModal,
  data() {
    return {
      isChecked: this.initIsChecked(),
    };
  },
  methods: {
    handleTermsClick(e) {
      e.preventDefault();
      let handled = false;
      if (e.target.tagName === "A") {
        switch (e.target.pathname) {
          case "/terms-and-conditions":
            handled = this.showTermsModal(
              "Terms & Conditions",
              "terms-general"
            );
            break;
        }
      }

      if (handled) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    showTermsModal(title, which) {
      this.$store.dispatch("modals/show", { title: title, type: which });
      return true;
    },
    initIsChecked: function () {
      const stored = localStorage.getItem("isCheckedNotShowNewTermsPopup");
      if (stored === null) {
        return false;
      } else {
        return stored == "false";
      }
    },
  },
  watch: {
    isChecked: function () {
      localStorage.setItem("isCheckedNotShowNewTermsPopup", this.isChecked);
    },
  },
};
</script>
